import script from "./TextToSpeech.vue?vue&type=script&setup=true&lang=js"
export * from "./TextToSpeech.vue?vue&type=script&setup=true&lang=js"

import "./TextToSpeech.vue?vue&type=style&index=0&id=248100e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-248100e0"]])

export default __exports__